import React, { useEffect } from 'react';
import styles from './AdViseStep2.module.css';

const AdViseStep2 = ({setAdViseStep, stepProps, setStepProps, marginTop}) => {
    const whenMethodSelected = (method) => {
        setStepProps(prev => {
            const newProps = [...prev];
            newProps[2] = method;
            return newProps;
        });
    };

    const whenHomeButtonClicked = () => {
        const back = window.confirm("선택한 정보들이 모두 초기화돼요.\n\n정말 첫 화면으로 돌아갈까요?");
        if(back)
            setAdViseStep(0)
    };

    const whenNextButtonClicked = () => {
        if(stepProps[2]=='advise'){
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[8] = {...newProps[8], addLastPromotionPage: true}
                return newProps;
            });
            setAdViseStep(3);
        }
        else{
            setStepProps(prev => {
                const newProps = [...prev];
                newProps[8] = {...newProps[8], addLastPromotionPage: false}
                return newProps;
            });
            setAdViseStep(8);
        }
    };

    return (
        <div className={styles.outerframe}>
            <div className={styles.upperframe}>
                <img className={styles.backbuttonIcon} alt="" src="images/back_android.svg" onClick={()=>setAdViseStep(1)}/>
                <div className={styles.titleframe}>
                    <b className={styles.buttontitle}>STEP 2</b>
                    <div className={styles.stepdesc}>콘텐츠 제작 방식을 선택해주세요!</div>
                </div>
                <img className={styles.homebuttonIcon} alt="" src="images/home_outlined.svg" onClick={()=>whenHomeButtonClicked()}/>
            </div>
            <div className={styles.lowerframe} style={{height:`calc(100dvh - ${marginTop}px)`}}>
                <div className={styles.contentframe}>
                    <div className={stepProps[2]=='advise' ? styles.activebuttonframe : styles.disabledbuttonframe} onClick={()=>whenMethodSelected('advise')}>
                        <div className={styles.buttontextframe}>
                            <b className={styles.activebuttontitle}>AdVise.ai</b>
                            <div className={styles.acitvebuttonsub}>
                                    <p className={styles.p}>이미 등록된 핫플에 대한</p>
                                    <p className={styles.p}>콘텐츠 제작 시 활용</p>
                            </div>
                        </div>
                    </div>
                    <div className={stepProps[2]=='manual' ? styles.activebuttonframe2 : styles.disabledbuttonframe} onClick={()=>whenMethodSelected('manual')}>
                        <div className={styles.buttontextframe}>
                            <b className={styles.activebuttontitle}>직접 제작</b>
                            <div className={styles.acitvebuttonsub}>
                                    <p className={styles.p}>보유하고 있는 리소스로</p>
                                    <p className={styles.p}>직접 콘텐츠 제작</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className={styles.nextbuttonframe}>
                <div className={styles.nextbutton} onClick={()=>whenNextButtonClicked()}>
                    <b className={styles.nextbuttontext}>다음 →</b>
                </div>
            </div>
        </div>
    );
}

export default AdViseStep2;